import { render, staticRenderFns } from "./_epicpay.vue?vue&type=template&id=530e0ece&lang=pug&"
import script from "./_epicpay.vue?vue&type=script&lang=js&"
export * from "./_epicpay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports